import { defineComponent as _defineComponent } from 'vue'
import { onMounted, Ref, ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import SettingsMenuItem from "@/components/settings/settings-menu-item.component.vue";
import MyProfileComponent from "@/components/settings/my-profile.component.vue";
import ChangePasswordComponent from "@/components/settings/change-password.component.vue";
import { useParamsSync } from "@/composables/use-params-sync";
import SecurityLogsComponent from "@/components/settings/security-logs.component.vue";
import store from "@/store";
import BreadCrumbComponent from "@/components/bread-crumb-component.vue";
import ActiveIconWatermarkComponent from "@/components/settings/active-icon-watermark.component.vue";
import Student from "@/interfaces/student.interface";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type ActiveComponent =
  | "MY_PROFILE"
  | "CHANGE_PASSWORD"
  | "SECURITY_LOGS";


export default /*#__PURE__*/_defineComponent({
  __name: 'settings',
  setup(__props) {

let scope: { row: { date: string; details: string }; $index: number };

const activeComponent: Ref<ActiveComponent> = ref("MY_PROFILE");

const loading = ref(false);

let student: Ref<Student | undefined> = ref();

const getOneStudent = async () => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    student: Student;
  }>({
    method: "GET",
    url: `students/fetch-one/${store.state.userId}?with_logs=true`,
    loadingProperty: loading,
    showSuccessMessage: false,
  });

  if (!request) return;
  if (request.success && request.message == "STUDENT_FETCHED_SUCCESSFULLY") {
    student.value = request.student;
  }
};

onMounted(() => {
  useParamsSync({ key: "t", value: activeComponent });
  getOneStudent();
});

return { __sfc: true,scope, activeComponent, loading, student, getOneStudent, SettingsMenuItem, MyProfileComponent, ChangePasswordComponent, SecurityLogsComponent, BreadCrumbComponent, ActiveIconWatermarkComponent }
}

})